try {
    new MutationObserver(function () {});
    new Promise(function () {});
    Object.assign({}, {});
    document.fonts.ready.then(function () {});
} catch {
    var replacement = process.env.SPO ? "fpodisable=1" : "wpmeteordisable=1";
    var href = document.location.href;

    if (!(process.env.SPO ? href.match(/[?&]fpodisable/) : href.match(/[?&]wpmeteordisable/))) {
        var nhref = "";
        if (href.indexOf("?") == -1) {
            if (href.indexOf("#") == -1) {
                nhref = href + "?" + replacement;
            } else {
                nhref = href.replace("#", "?" + replacement + "#");
            }
        } else {
            if (href.indexOf("#") == -1) {
                nhref = href + "&" + replacement;
            } else {
                nhref = href.replace("#", "&" + replacement + "#");
            }
        }
        document.location.href = nhref;
    }
}
